module.exports = __webpack_public_path__ + "static/img/aa-4.7904b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa-4.png
// module id = g9J7
// module chunks = 1